import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    search: '',
  },
  pagination: {
    limit: 25,
  },
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.app.catalogos.codigo_postal = {
      ...state.app.catalogos.codigo_postal,
      filters: {
        ...state.app.catalogos.codigo_postal.filters,
        ...meta,
      },
      busy: true,
    };
  });

  try {
    const { filters, pagination } = store.state.app.catalogos.codigo_postal;

    const params = {
      ...filters,
      ...meta,
      limit: pagination.limit,
      page: meta.page || 1,
    };

    const response = await Http.get('catalogos/codigos-postales', { params });

    store.setState((state) => {
      state.app.catalogos.codigo_postal = {
        ...state.app.catalogos.codigo_postal,
        busy: false,
        data: response.data,
        pagination: {
          ...state.app.catalogos.codigo_postal.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.catalogos.codigo_postal.busy = false;
      state.app.catalogos.codigo_postal.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.catalogos.codigo_postal = {
      ...initialState,
    };
  });
};

const CodigoPostalSuggestionsStore = {
  state: () => initialState,
  actions: {
    paginate,
    reset,
  },
};

export default CodigoPostalSuggestionsStore;
